// RTK Query keeps returning the previous args' data until the new request resolves, so right after
// switching/adding an option the "current" estimate detail can still be the OLD option's (QA #37).
import type { EstimateVersionDetail } from '@/redux/internal-services/estimatesApi';

export function detailMatchesOption(
  detail: EstimateVersionDetail | undefined,
  optionId: string | undefined,
): boolean {
  return !!detail && !!optionId && detail.estimate?.option_id === optionId;
}
